import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Transition } from "@headlessui/react";
import {
  editProfile,
  fetchUserProfile,
  getBankList,
  getCountryList,
  getNonNigerianBanksList,
  updatebBank,
  updateSocial,
} from "../../../api-client/profile";
import { useCookies } from "react-cookie";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { DashCard } from "../card";
// import { EditInput } from "../input";

import CountryModalBank, {
  AddBankModal,
  CountryModal,
  NonNigerianBankModal,
} from "../../widgets/modals/select-modal";
import Button from "../button";
import Countries from "../../sections/profile/Country";
import CountryModalBanks from "../../sections/profile/Country";
import { EditInput } from "../input/profileEdit";

const updateProfile = async () => {
  setLoading(true);

  const data = {
    firstName,
    lastName,
    phone,
    phone2,
    country: selectedCountry,
  };

  try {
    const res = await editProfile(data);
    setLoading(false);
    setFirstNameFocus(false);
    setLastNameFocus(false);
    setPhoneFocus(false);
    setPhone2Focus(false);
    setSelectCountryModal(false);

    setFirstName(res?.data?.data?.firstName);
    setLastName(res?.data?.data?.lastName);
    setPhone(res?.data?.data?.phone);
    setPhone2(res?.data?.data?.phone2);
    setCountry(res?.data?.data?.country);

    toast.success(res.data.message);
  } catch (error) {
    setLoading(false);
    toast.error(error.response.data.message);
  }
};
const Sidebar = () => {
  const [open, setOpen] = useState(false);

  const [socialUpdateLoading, setUpdateSocialLoading] = useState(false);
  const [loading, setLoading] = useState();
  const [updateBankLoading, setUpdateBankLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [cookie, setCookie] = useCookies();
  const [_banks, setBanks] = useState([]);
  const [_mobileMoney, setMobileMoney] = useState([]);
  const [profileEditMode, setProfileEditMode] = useState(false);

  const { data: _countryList, isCountryLoading } = useQuery(
    ["country-list"],
    getCountryList
  );

  const [addBankModal, setAddBankModal] = useState(false);
  const [selectCountryModal, setSelectCountryModal] = useState(false);
  const [nonNigerianBankModal, setNonNigerianBankModal] = useState(false);
  const [selectedBank, setSelectedBank] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [countryValue, setCountryValue] = useState("");
  // input State
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [phone2, setPhone2] = useState("");
  const [country, setCountry] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountNo, setAccountNo] = useState("");
  const [twitter, setTwitter] = useState("");
  const [instagram, setInstagram] = useState("");
  const [tiktok, setTiktok] = useState("");
  const [facebook, setFacebook] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [nonNgBankAccountName, setNonNgBankAccountName] = useState("");

  const [firstNameFocus, setFirstNameFocus] = useState(false);
  const [lastNameFocus, setLastNameFocus] = useState(false);
  const [phoneFocus, setPhoneFocus] = useState(false);
  const [phone2Focus, setPhone2Focus] = useState(false);

  const [twitterFocus, setTwitterFocus] = useState(false);
  const [instagramFocus, setInstagramFocus] = useState(false);
  const [tiktokFocus, setTiktokFocus] = useState(false);
  const [facebookFocus, setFacebookFocus] = useState(false);

  const [updateBtnLoading, setUpdateBtnLoading] = useState(false);

  const level = useMemo(() => cookie?.user?.userData[0]?.level, [cookie]);
  const banks = useMemo(
    () =>
      _banks.map((val) => ({
        label: val.name,
        value: val.code,
      })),
    [_banks]
  );

  const countryList = useMemo(
    () =>
      _countryList?.data?.data.map((val) => ({
        label: val.name,
        value: val.code,
      })),
    [_countryList]
  );

  const mobileMoney = useMemo(
    () =>
      _mobileMoney?.map((val) => ({
        label: val.bankName,
        value: val.bankCode,
      })),
    [_mobileMoney]
  );

  const updateProfile = async () => {
    setLoading(true);
    const data = {
      firstName,
      lastName,
      phone,
      phone2,
      country: selectedCountry,
      dateOfBirth,

    };

    try {
      const res = await editProfile(data);
      setFirstName(res.data.data.firstName);
      setLastName(res.data.data.lastName);
      setDateOfBirth(res.data.data.dateOfBirth);
      setPhone(res.data.data.phone);
      setPhone2(res.data.data.phone2);
      setCountry(res.data.data.country);
      toast.success(res.data.message);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      // reject(error);
    } finally {
      setLoading(false);
    }
  };

  const updateSocialMedia = async () => {
    setUpdateSocialLoading(true);
    const data = { twitter, instagram, tiktok, facebook };

    try {
      const res = await updateSocial(data);
      toast.success(res.data.message);
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    } finally {
      setUpdateSocialLoading(false);
    }
  };

  const updateBankDetails = async () => {
    setUpdateBankLoading(true);
    const data = {
      bankName: selectedBank,
      bankCode,
      accountNumber: accountNo?.replace(/[^a-zA-Z0-9 ]/g, ""),
      accountName: nonNgBankAccountName,
    };

    try {
      const res = await updateBank(data);
      setAccountName(res.data.data.accountName);
      setAccountNumber(res.data.data.accountNumber);
      setBankName(res.data.data.bankName);
      toast.success(res.data.message);
    } catch (error) {
      toast.error("Invalid Bank Details! Please try again.");
    } finally {
      setUpdateBankLoading(false);
    }
  };

  // Create Reference for All fields
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const phoneRef = useRef();
  const phone2Ref = useRef();
  const passwordRef = useRef();
  const accountNumberRef = useRef();
  const twitterRef = useRef();
  const instagramRef = useRef();
  const emailRef = useRef();
  const countryRef = useRef();
  const tiktokRef = useRef();
  const facebookRef = useRef();
  const dateOfBirthRef = useRef();

  // Get User
  const getUser = async () => {
    setLoading(true);
    try {
      const res = await fetchUserProfile();
      const { user, profile } = res?.data?.data;
      setFirstName(user?.firstName);
      setLastName(user?.lastName);
      setPhone(user?.phone);
      setPhone2(user?.phone2);
      setEmail(user?.email);
      setDateOfBirth(user?.dateOfBirth);
      setCountry(user?.country);
      setAccountNumber(profile?.accountNumber);
      setBankName(profile?.bankName);
      setAccountName(profile?.accountName);
      setTwitter(profile?.twitter);
      setInstagram(profile?.instagram);
      setFacebook(profile?.facebook);
      setTiktok(profile?.tiktok);

      setLoading(false);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      // reject(error);
    }
  };

  const handleUpdate = async () => {
    setUpdateBtnLoading(true);

    const data = {
      firstName,
      lastName,
      phone,
      phone2,
      dateOfBirth,
      country: selectedCountry,
      twitter,
      instagram,
      tiktok,
      facebook,
    };

    try {
      const res = await editProfile(data);
      setLoading(false);
      setFirstNameFocus(false);
      setLastNameFocus(false);
      setPhoneFocus(false);
      setPhone2Focus(false);
      setTwitterFocus(false);
      setInstagramFocus(false);
      setTiktokFocus(false);
      setFacebookFocus(false);
      setSelectCountryModal(false);
      // setDateOfBirthFocus(false);

      setFirstName(res?.data?.data?.firstName);
      setLastName(res?.data?.data?.lastName);
      setPhone(res?.data?.data?.phone);
      setPhone2(res?.data?.data?.phone2);
      setCountry(res?.data?.data?.country);
      setTwitter(res?.data?.data?.twitter);
      setInstagram(res?.data?.data?.instagram);
      setFacebook(res?.data?.data?.facebook);
      setTiktok(res?.data?.data?.tiktok);
      // setDateOfBirth(res?.data?.data?.dateOfBirth);

      toast.success(res.data.message);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      // reject(error);
    }
  };

  // const handleUpdate = async () => {
  //   setLoading(true);
  //   const data = {
  //     firstName,
  //     lastName,
  //     phone,
  //     phone2,
  //     country: selectedCountry,
  //     twitter,
  //     instagram,
  //     tiktok,
  //     facebook,
  //   };

  //   try {
  //     const res = await editProfile(data);
  //     // Update profile data
  //     setFirstName(res.data.data.firstName);
  //     setLastName(res.data.data.lastName);
  //     setPhone(res.data.data.phone);
  //     setPhone2(res.data.data.phone2);
  //     setCountry(res.data.data.country);
  //     setTwitter(res.data.data.twitter);
  //     setInstagram(res.data.data.instagram);
  //     setFacebook(res.data.data.facebook);
  //     setTiktok(res.data.data.tiktok);
  //     setLoading(false);
  //     toast.success(res.data.message);
  //   } catch (error) {
  //     setLoading(false);
  //     toast.error(error.response.data.message);
  //   }
  // };

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    // This effect is used to handle any side effects when the sidebar is opened or closed
  }, [open]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {addBankModal && (
        <AddBankModal
          setAddBankModal={setAddBankModal}
          options={banks}
          selectedInput={selectedBank}
          setSelectedInput={setSelectedBank}
          loading={updateBankLoading}
          updateBank={updateBank}
          accountNumber={accountNumber}
          accountNo={accountNo}
          setAccountNo={setAccountNo}
          setAccountNumber={setAccountNumber}
          value={bankCode}
          setValue={setBankCode}
        />
      )}
      {nonNigerianBankModal && (
        <NonNigerianBankModal
          setNonNigerianBankModal={setNonNigerianBankModal}
          options={mobileMoney}
          selectedInput={selectedBank}
          setSelectedInput={setSelectedBank}
          loading={updateBankLoading}
          updateBank={updateBank}
          accountNumber={accountNumber}
          accountNo={accountNo}
          accountName={nonNgBankAccountName}
          setAccountName={setNonNgBankAccountName}
          setAccountNo={setAccountNo}
          setAccountNumber={setAccountNumber}
          value={bankCode}
          setValue={setBankCode}
        />
      )}
      {selectCountryModal && (
        <CountryModal
          loading={loading}
          setSelectCountryModal={setSelectCountryModal}
          options={countryList}
          selectedInput={selectedCountry}
          setSelectedInput={setSelectedCountry}
          updateProfile={updateProfile}
          value={countryValue}
          setValue={setCountryValue}
        />
      )}
      <div className="flex justify-center items-center  ">
        <div>
          <Transition
            show={open}
            enter="transition-opacity ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-in duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            className="fixed inset-0  overflow-hidden z-[0]"
          >
            <div className="absolute inset-0 bg-[#205363] bg-opacity-75 transition-opacity"></div>
          </Transition>
          <section className="absolute inset-y-0 right-0 lg:pl-10 max-w-full flex">
            <Transition
              show={open}
              enter="transition-transform ease-out duration-300"
              enterFrom="transform translate-x-full"
              enterTo="transform translate-x-0"
              leave="transition-transform ease-in duration-300"
              leaveFrom="transform translate-x-0"
              leaveTo="transform translate-x-full"
              className="w-screen  max-w-2xl lg:max-w-2xl  lg:m-7 m-2 lg:mr-9 mr-1"
            >
              <div className=" flex flex-col py-6 bg-white rounded-[24px] p-2 lg:p-5">
                {/* Sidebar Header */}
                <div className="flex items-center justify-between lg:px-4  m-3 pt-8 pb-10 border-b-[1px] ">
                  <div className="flex  flex-col">
                    <h2 className="lg:text-[22px] text-[12px] text-[#205363] font-[600] ">
                      Edit Personal Information
                    </h2>
                    <h2 className="text-[12px] text-[#828282] leading-[16px]  ">
                      Adjust Your personal <br className="lg:hidden flex" />{" "}
                      information and keep it updated
                    </h2>
                  </div>
                  <button
                    onClick={() => setOpen(false)}
                    className="text-[#205363] flex items-center border-[1px] border-[#205363] rounded-[10px] py-3 px-3 w-[89px] h-[40px]"
                  >
                    <span className=" text-[#205363] text-[12px] leading-[16.8px] mx-2">
                      Close
                    </span>
                    <svg
                      className="h-[16px] w-[16px] border-[1px] border-[#205363] rounded-full"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className=" px-4   z-1">
                  <div className="mt-6">
                    <section className="flex flex-col   mt-3">
                      <div>
                        <h4 className="text-[#828282] text-[14px] leading-[16.9px] font-[500]  ">
                          First Name
                        </h4>
                        <div className="border-[1px] px-5 mt-2 border-[#B3BAC5] rounded-[8px]">
                          <EditInput
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            placeholder="Edit First Name"
                            inputRef={firstNameRef}
                            onFocus={() => setFirstNameFocus(true)}
                            // className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                          />
                        </div>
                      </div>
                    </section>
                    <section className="flex flex-col   my-5">
                      <div>
                        <h4 className="text-[#828282] text-[14px] font-[500] mb-3 ">
                          Last Name
                        </h4>
                        <div className="border-[1px]  mt-2 border-[#B3BAC5] rounded-[8px] px-5">
                          <EditInput
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            placeholder="Edit Last Name"
                            inputRef={lastNameRef}
                            onFocus={() => setLastNameFocus(true)}
                            onBlur={() => setLastNameFocus(false)}
                            // className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                          />
                        </div>
                      </div>
                    </section>
                    <section className="flex flex-col   my-5">
                      <div>
                        <h4 className="text-[#828282] text-[14px] font-[500] mb-3">
                          Email
                        </h4>
                        <div className=" px-5 mt-2 h-[56px] flex items-center  bg-[#F4F5F7] rounded-[8px]">
                          <span className=" text-[#828282]">{email} </span>
                        </div>
                      </div>
                    </section>
                    <section className="flex flex-col   my-5">
                      <div>
                        <h4 className="text-[#828282] text-[14px] font-[500] mb-3 leading-[16px]">
                          Date Of Birth
                        </h4>
                        <div className="border-[1px] px-5 mt-2 border-[#B3BAC5] rounded-[8px]">
                        <EditInput
  type="date"
  className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-800"
  onChange={(e) => setDateOfBirth(e.target.value)}
  value={dateOfBirth}
/>
                        </div>
                      </div>
                    </section>
                    <section className="flex flex-col   my-5">
                      <div>
                        <h4 className="text-[#828282] text-[14px] font-[500] mb-3  leading-[16px]">
                          Phone Number (Primary)
                        </h4>
                        <div className="border-[1px] px-5 mt-2 border-[#B3BAC5] rounded-[8px]">
                          <EditInput
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="Edit Phone Number"
                            inputRef={phoneRef}
                            // className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                            onFocus={() => setPhoneFocus(true)}
                          />
                        </div>
                      </div>
                    </section>
                    
                    <section className="flex flex-col   my-5">
                      <div>
                        <h4 className="text-[#828282] text-[14px] font-[500] mb-3 leading-[16px]">
                          Phone Number (Secondary)
                        </h4>
                        <div className="border-[1px] px-5 mt-2 border-[#B3BAC5] rounded-[8px]">
                          <EditInput
                            value={phone2}
                            onChange={(e) => setPhone2(e.target.value)}
                            placeholder="Edit Phone Number 2"
                            inputRef={phone2Ref}
                            onFocus={() => setPhone2Focus(true)}
                            // className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                          />
                        </div>
                      </div>
                    </section>
                    <section className="  mt-5">
                      <h4 className="text-[#828282] text-[14px] font-[500] mb-1 ">
                        Country{" "}
                      </h4>
                      {/* <div
                        className="border-[1px] px-5 mt-2  border-[#B3BAC5] rounded-[8px] flex justify-between"
                        onClick={() => setSelectCountryModal(true)}
                      >
                        <EditInput
                          value={country}
                          placeholder="Select Country"
                          inputRef={countryRef}

                          //className="border-[1px] rounded-[8px] border-[#B3BAC5] w-full"
                        />
                        
                        <p className="">
                          <svg
                            width="24"
                            height="24"
                            className="mt-3 text-neutral-light-50"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_6331_26555)">
                              <path
                                d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
                                fill="black"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_6331_26555">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </p>
                      </div> */}

                      <CountryModal
                        loading={loading}
                        setSelectCountryModal={setSelectCountryModal}
                        options={countryList}
                        selectedInput={selectedCountry}
                        setSelectedInput={setSelectedCountry}
                        updateProfile={updateProfile}
                        value={countryValue}
                        setValue={setCountryValue}
                      />
                    </section>

                    {/* <section className="flex flex-col mt-5">
                        <div>
                          <h4 className="text-[#282828] text-[14px] font-[500] ">
                            Twitter
                          </h4>
                          <EditInput
                            value={twitter}
                            onChange={(e) => setTwitter(e.target.value)}
                            placeholder="Edit Twitter Handle"
                            inputRef={twitterRef}
                            onFocus={() => setTwitterFocus(true)}
                          />
                        </div>
                      </section>
                                  <section className="flex flex-col mt-5">
                      <div>
                        <h4 className="text-[#282828] text-[14px] font-[500] ">
                          Instagram
                        </h4>
                        <EditInput
                          value={instagram}
                          onChange={(e) => setInstagram(e.target.value)}
                          placeholder="Edit Instagram Handle"
                          inputRef={instagramRef}
                          onFocus={() => setInstagramFocus(true)}
                        />
                      </div>
                    </section>
                    <section className="flex flex-col mt-5">
                      <div>
                        <h4 className="text-[#282828] text-[14px] font-[500] ">TikTok</h4>
                        <EditInput
                          value={tiktok}
                          onChange={(e) => setTiktok(e.target.value)}
                          placeholder="Edit TikTok Handle"
                          inputRef={tiktokRef}
                          onFocus={() => setTiktokFocus(true)}
                        />
                      </div>
                    </section>
                    <section className="flex flex-col mt-5">
                      <div>
                        <h4 className="text-[#282828] text-[14px] font-[500] ">Facebook</h4>
                        <EditInput
                          value={facebook}
                          onChange={(e) => setFacebook(e.target.value)}
                          placeholder="Edit Facebook Handle"
                          inputRef={facebookRef}
                          onFocus={() => setFacebookFocus(true)}
                        />
                      </div>
                    </section> */}
                    {/* Update Button */}
                    <div className=" mt-10 flex items-end justify-end border-t-[1px] pt-7 ">
                      <Button
                        className="w-[161px] py-[13px] bg-[#205363] text-light"
                        loading={loading}
                        onClick={handleUpdate} // Call handleUpdate function here
                        label="Save Changes"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </section>
          {/* Open sidebar button
           <div className="lg:w-[144px] w-[120px] lg:w-[159px] w-[120px]" ">
           */}
          <button
            onClick={() => setOpen(true)}
            className="px-10 py-5 border-[1px] text-[#205363] lg:w-[159px] w-[120px] h-[46px]  leading-[14px] text-[13px] font-[500]  rounded-xl border-[#205363]"
          >
            Edit
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
// import React, { useState, useEffect } from 'react';
// import { Transition } from '@headlessui/react';

// const Sidebar = () => {
//   const [open, setOpen] = useState(false);

//   useEffect(() => {
//     // This effect is used to handle any side effects when the sidebar is opened or closed
//   }, [open]);

//   return (
//     <div className="flex justify-center items-center min-h-screen">
//       <div>
//         {/* Sidebar Overlay */}
//         <Transition
//           show={open}
//           enter="transition-opacity ease-out duration-300"
//           enterFrom="opacity-0"
//           enterTo="opacity-100"
//           leave="transition-opacity ease-in duration-300"
//           leaveFrom="opacity-100"
//           leaveTo="opacity-0"
//           className="fixed inset-0  overflow-hidden z-[0]"
//         >
//           <div className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
//         </Transition>
//         {/* Sidebar Content */}
//         <section className="absolute inset-y-0 right-0 pl-10 max-w-full flex">
//           <Transition
//             show={open}
//             enter="transition-transform ease-out duration-300"
//             enterFrom="transform translate-x-full"
//             enterTo="transform translate-x-0"
//             leave="transition-transform ease-in duration-300"
//             leaveFrom="transform translate-x-0"
//             leaveTo="transform translate-x-full"
//             className="w-screen max-w-md"
//           >
//             <div className="h-full flex flex-col py-6 bg-white shadow-xl">
//               {/* Sidebar Header */}
//               <div className="flex items-center justify-between px-4">
//                 <h2 className="text-xl font-semibold text-black">Search</h2>
//                 <button onClick={() => setOpen(false)} className="text-gray-500 hover:text-gray-700">
//                   <span className="sr-only">Close</span>
//                   <svg
//                     className="h-6 w-6"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                     aria-hidden="true"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>
//               {/* Search Input */}
//               <div className="mt-4 px-4">
//                 <input
//                   type="text"
//                   placeholder="Search post here"
//                   className="w-full p-2 border border-gray-300 rounded-md focus:border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 transition-colors duration-300"
//                 />
//               </div>
//               <div className="mt-4 px-4">
//                 <p className="ml-2 text-gray-400">Results</p>
//               </div>
//               {/* Sidebar Content */}
//               <div className="mt-4 px-4 h-full overflow-auto">
//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   {/* Cards */}
//                   {[...Array(8).keys()].map((i) => (
//                     <div
//                       key={i}
//                       className="bg-gray-50 hover:bg-gray-100 p-4 cursor-pointer rounded-md border border-gray-300 transition-colors duration-300"
//                     >
//                       <h3 className="text-lg font-semibold text-black mb-2">Card {i + 1}</h3>
//                       <p className="text-gray-600">Content for card {i + 1}.</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               {/* Sidebar Footer */}
//               <div className="mt-6 px-4">
//                 <button className="flex justify-center items-center bg-black text-white rounded-md text-sm p-2 gap-1">
//                   <svg
//                     width="1rem"
//                     height="1rem"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       fillRule="evenodd"
//                       clipRule="evenodd"
//                       d="M3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H4C3.44772 8 3 7.55228 3 7ZM6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12ZM9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17Z"
//                       fill="currentColor"
//                     ></path>
//                   </svg>
//                   Filters
//                 </button>
//               </div>
//             </div>
//           </Transition>
//         </section>
//         {/* Open sidebar button */}
//         <button
//           onClick={() => setOpen(true)}
//           className="px-4 py-2 bg-black text-white rounded-md"
//         >
//           Open Sidebar
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;
